import { useContext } from 'react';

import { type BaseFeatureFlags } from '../../launch-darkly.types';
import { type LaunchDarklyProviderContext } from '../../provider/launch-darkly.context';

// ─────────────────────────────────────────────────────────────────────────────

export const useLaunchDarklyFactory = <FeatureFlags extends BaseFeatureFlags>(
  params: Params<FeatureFlags>,
) => {
  const { Context } = params;

  const context = useContext(Context);

  if (!context) {
    throw new Error('Cannot be used outside `LaunchDarklyProvider`');
  }

  return context;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params<FeatureFlags extends BaseFeatureFlags> = {
  Context: LaunchDarklyProviderContext<FeatureFlags>;
};
